export default __webpack_public_path__ + "static/media/applebadge2.8c4986ee.svg";